import PropTypes from "prop-types";
import React from "react";
import { Button, Table, Glyphicon, Checkbox } from "react-bootstrap";
import _ from "lodash";

import AccountActions from "../actions/AccountActions";

import CategoryStore from "../stores/CategoryStore";

import AccountingHelper from "../utils/AccountingHelper";
import Api from "../utils/Api";
import DateHelper from "../utils/DateHelper";
import DatePicker from "../utils/DatePicker";

import CategorySelect from "./CategorySelect";
import DescriptionComplete from "./DescriptionComplete";
import InputAmount from "./InputAmount";
import ModalWrapper from "./ModalWrapper";

export default class SplitTransactionEdit extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			loading: true
		};

		this.handleClose = this.handleClose.bind(this);
		this.handleNewLineItem = this.handleNewLineItem.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.handleTransactionDateChange = this.handleTransactionDateChange.bind(this);
	}

	async handleSave()
	{
		const transaction = this.state.transaction;
		transaction.lineItems = this.state.lineItems;

		await AccountActions.saveTransaction(transaction);
		this.handleClose();
	}

	handleClose()
	{
		this.props.onClose();
	}

	handleTransactionDateChange(dateValue)
	{
		const transaction = this.state.transaction;
		transaction.date = dateValue;

		this.setState({transaction});
	}

	handleLineItemDescriptionSelect(lineItem, index, lineItemPrefill)
	{
		lineItem.description = lineItemPrefill.description;
		if (!lineItem.categoryId)
		{
			lineItem.categoryId = lineItemPrefill.categoryId;
			lineItem.isExpense = this.isCategoryExpense(lineItemPrefill.categoryId);
			lineItem.isCreditRefund = false;
			if (lineItem.isExpense && lineItemPrefill.amount > 0)
			{
				lineItem.isCreditRefund = true;
			}
			else if (!lineItem.isExpense && lineItemPrefill.amount < 0)
			{
				lineItem.isCreditRefund = true;
			}
		}
		if (!lineItem.amount)
		{
			lineItem.amount = Math.abs(lineItemPrefill.amount);
		}

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({lineItems});
	}

	handleLineItemDescriptionChange(lineItem, index, value)
	{
		lineItem.description = value;

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({lineItems});
	}

	handleLineItemCategoryChange(lineItem, index, category)
	{
		lineItem.categoryId = category ? category.id : null;
		lineItem.isExpense = this.isCategoryExpense(lineItem.categoryId);
		lineItem.amount = this.getLineItemSignedValue(lineItem, lineItem.amount);

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({lineItems});
	}

	handleLineItemAmountChange(lineItem, index, value)
	{
		lineItem.amount = this.getLineItemSignedValue(lineItem, value);

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({lineItems});
	}

	handleLineItemIsCreditRefundChange(lineItem, index, event)
	{
		lineItem.isCreditRefund = event.target.checked;
		lineItem.amount = this.getLineItemSignedValue(lineItem, lineItem.amount);

		const lineItems = this.state.lineItems;
		lineItems[index] = lineItem;
		this.setState({ lineItems });
	}

	handleNewLineItem()
	{
		const lineItems = this.state.lineItems;
		lineItems.push({amount: 0, isExpense: true});
		this.setState({lineItems});
	}

	handleLineItemDelete(index)
	{
		const lineItems = this.state.lineItems;
		lineItems.splice(index, 1);
		this.setState({lineItems});
	}

	handleTransactionLoaded(transaction)
	{
		const lineItems = transaction.lineItems;
		delete transaction.lineItems;
		if (lineItems.length < 2)
		{
			lineItems.push({amount: 0});
		}

		lineItems.forEach((lineItem) =>
		{
			if (lineItem.categoryId)
			{
				lineItem.isExpense = this.isCategoryExpense(lineItem.categoryId);
				if ((!lineItem.isExpense && lineItem.amount < 0) || (lineItem.isExpense && lineItem.amount > 0))
				{
					lineItem.isCreditRefund = true;
				}
			}
		});

		this.setState({
			transaction,
			lineItems,
			loading: false
		});
	}

	isCategoryExpense(categoryId)
	{
		const inputCategory = this.categories.find(cat => cat.id === categoryId);
		if (inputCategory && inputCategory.type === Enums.categoryType.expense)
		{
			return true;
		}
		return false;
	}

	getLineItemSignedValue(lineItem, value)
	{
		value = Math.abs(value);
		if ((lineItem.isExpense && !lineItem.isCreditRefund) || (!lineItem.isExpense && lineItem.isCreditRefund))
		{
			value *= -1;
		}
		return value;
	}

	async loadExistingTransaction()
	{
		try
		{
			const transaction = await Api.getTransaction(this.props.transactionId);
			this.handleTransactionLoaded(transaction);
		}
		catch (message)
		{
			// TODO: BA-152 handle error
			console.error(message);
		}
	}

	componentDidMount()
	{
		this.categories = CategoryStore.getCategories();
		if (!this.props.isNew)
		{
			this.loadExistingTransaction();
		}
		else
		{
			const newSplitDetails = this.props.newSplitDetails;
			const newTransaction = {
				lineItems: [],
				date: DateHelper.getCurrentDate().toISOString(),
				isNew: true,
				accountId: this.props.accountId,
				isExpense: true
			};
			if (newSplitDetails.date)
			{
				newTransaction.date = newSplitDetails.date;
			}
			if (newSplitDetails.description || newSplitDetails.categoryId || newSplitDetails.amount || newSplitDetails.isCreditRefund)
			{
				let newLineItem = {
					description: newSplitDetails.description,
					categoryId: newSplitDetails.categoryId,
					amount: newSplitDetails.amount,
					isCreditRefund: newSplitDetails.isCreditRefund,
				};
				newLineItem.amount = this.getLineItemSignedValue(newLineItem, newLineItem.amount);
				newTransaction.lineItems.push(newLineItem);
			}
			this.handleTransactionLoaded(newTransaction);
		}
	}

	render()
	{
		const categories = this.categories;
		const {currencyId, numberDecimals} = this.props;
		const transaction = this.state.transaction;
		const lineItems = this.state.lineItems;
		const totalAmount = _.sumBy(lineItems, lineItem =>
		{
			const value = +lineItem.amount;
			return isNaN(value) ? 0 : value;
		});

		const footerElements = [
			<Button key={0} bsStyle={"primary"} onClick={this.handleSave}>Save</Button>,
			<Button key={1} onClick={this.handleClose}>Close</Button>
		];

		return (
			<ModalWrapper
				title={"Transaction Details"}
				footerElements={footerElements}
			>
				{this.state.loading ?
					<div className={"text-center"}>
						<Glyphicon glyph={"refresh"} className={"spinning"} />
						<span> Loading</span>
					</div>
					:
					<div>
						<div className={"form-group row"}>
							<label
								className={"col-sm-4"}
								htmlFor={"splitTransactionDate"}
							>
								Transaction Date
							</label>
							<div className={"col-sm-8"}>
								<DatePicker
									id={"splitTransactionDate"}
									className={"input-sm"}
									value={DateHelper.toISOString(transaction.date)}
									onChange={this.handleTransactionDateChange}
									showClearButton={false}
								/>
							</div>
						</div>
						<Table>
							<thead>
								<tr>
									<th className={"col-md-5"}>
										<span className={"unselectable"}>Description</span>
									</th>
									<th className={"col-md-3"}>
										<span className={"unselectable"}>Category</span>
									</th>
									<th className={"col-md-2"}>
										<span className={"unselectable"}>Amount</span>
									</th>
									<th className={"col-md-1"} />
									<th className={"col-md-1"}>
										<span className={"unselectable"}>Delete</span>
									</th>
								</tr>
							</thead>
							<tbody>
								{lineItems.map((lineItem, index) => {
									return (
										<tr key={index}>
											<td>
												<DescriptionComplete
													value={lineItem.description || ""}
													onSelect={this.handleLineItemDescriptionSelect.bind(this, lineItem, index)}
													onChange={this.handleLineItemDescriptionChange.bind(this, lineItem, index)}
													autoFocus={true}
												/>
											</td>
											<td>
												<CategorySelect
													onSelect={this.handleLineItemCategoryChange.bind(this, lineItem, index)}
													value={lineItem.categoryId}
													options={categories}
												/>
											</td>
											<td>
												<InputAmount
													value={Math.abs(lineItem.amount)}
													onChange={this.handleLineItemAmountChange.bind(this, lineItem, index)}
													numberDecimals={numberDecimals}
												/>
											</td>
											<td>
												<Checkbox
													defaultChecked={lineItem.isCreditRefund}
													onBlur={this.handleFieldBlur}
													defaultValue={lineItem.isCreditRefund}
													onChange={this.handleLineItemIsCreditRefundChange.bind(this, lineItem, index)}
												>
													{lineItem.isExpense ? "Refund" : "Credit"}
												</Checkbox>
											</td>
											<td>
												<Button
													bsSize={"sm"}
													bsStyle={"danger"}
													onClick={this.handleLineItemDelete.bind(this, index)}
												>
													<Glyphicon glyph={"trash"}/>
												</Button>
											</td>
										</tr>
									);
								})}
								<tr>
									<td>
										<Button bsStyle={"link"} onClick={this.handleNewLineItem}>Add new</Button>
									</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td>Total</td>
									<td/>
									<td>
										{AccountingHelper.formatMoney(totalAmount, currencyId)}
									</td>
									<td/>
								</tr>
							</tfoot>
						</Table>
					</div>
				}
			</ModalWrapper>
		);
	}
}

SplitTransactionEdit.propTypes = {
	onClose: PropTypes.func,
	isNew: PropTypes.bool,
	transactionId: PropTypes.number,
	accountId: PropTypes.number,
	newSplitDetails: PropTypes.object,
	currencyId: PropTypes.number,
	numberDecimals: PropTypes.number,
};



// WEBPACK FOOTER //
// ./Components/components/SplitTransactionEdit.jsx